import { AlertTriangle, RefreshCw, Home } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { FallbackRender } from '@sentry/react'
import { isChunkLoadError } from '@/utils/error'

export const GlobalError: FallbackRender = ({ resetError, error }) => {
  const handleGoHome = () => {
    window.location.href = '/'
  }

  const handleReload = () => {
    window.location.reload()
  }

  const needsRefresh = isChunkLoadError(error)

  const title = needsRefresh ? 'Application Update Required' : 'Something went wrong'
  const description = needsRefresh
    ? 'The application has been updated. Please reload to get the latest version.'
    : 'We apologize for the inconvenience. An unexpected error has occurred.'

  const handleTryAgain = () => {
    resetError()
    if (needsRefresh) {
      handleReload()
    } else {
      resetError()
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-destructive/10 rounded-full">
              <AlertTriangle className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle className="text-xl">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-2">
            <Button onClick={handleTryAgain} className="flex-1" variant="default">
              <RefreshCw className="h-4 w-4 mr-2" />
              {needsRefresh ? 'Reload Application' : 'Try Again'}
            </Button>
            {!needsRefresh && (
              <Button onClick={handleGoHome} variant="outline" className="flex-1">
                <Home className="h-4 w-4 mr-2" />
                Go Home
              </Button>
            )}
          </div>

          {!needsRefresh && (
            <div className="text-center text-xs text-muted-foreground pt-2 border-t">
              <div className="mb-1">This error has been automatically reported to our team.</div>
              <div>If this problem persists, please contact support.</div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
